import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TuiAccordion } from '@taiga-ui/experimental';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-adult-lern',
  standalone: true,
  imports: [TuiAccordion, TranslocoDirective],
  templateUrl: './adult-lern.component.html',
  styleUrl: './adult-lern.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdultLernComponent {}
